import React from 'react';
import { Card, CardHeader, CardContent, TextField } from '@mui/material';

export default function AccountingNotes ({ formik }) {
  return (
    <Card sx={{ m: 2, mt: 0 }}>
      <CardHeader title="Uwagi księgowe"/>
      <CardContent>
        <TextField
          id="accounting_notes"
          value={formik.values.accounting_notes}
          onChange={formik.handleChange}
          multiline
          rows={8}
          fullWidth
        />
      </CardContent>
    </Card>
  );
};
